<script>
	import Details from './Details.svelte';
	import Food from './Food.svelte';
	import Advertisement from './Advertisement.svelte';


	// Import the functions you need from the SDKs you need
	import { initializeApp } from "@firebase/app";
	//import { getAnalytics } from "firebase/compat/analytics";
	import { getFirestore, doc, collection, getDocs, getDoc, query, limit, where, setDoc } from "firebase/firestore";
	import { getAuth, signInAnonymously, onAuthStateChanged} from "firebase/auth";

  	import { element } from 'svelte/internal';

	import Cookies from 'js-cookie'

	import * as htmlToImage from "html-to-image";

	const firebaseConfig = {
		apiKey: "AIzaSyA6BjZ0g4ijgyzq1yk-yCA00gSI1ozyKsY",
		authDomain: "toothpicky-b2dec.firebaseapp.com",
		projectId: "toothpicky-b2dec",
		storageBucket: "toothpicky-b2dec.appspot.com",
		messagingSenderId: "680332774561",
		appId: "1:680332774561:web:4fb6e53f482be11fce74e0",
		measurementId: "G-NV45LRBJ9L"
	};
	async function SendFoods(){
		function capitalize(str){
			return str.charAt(0).toUpperCase() + str.slice(1);
		}

		let foodsjson = await (await fetch('./finalfoods.json')).json();
		for(let i = 0; i < Array.from(foodsjson).length; i++){
			let element = foodsjson[i];
			await setDoc(doc(db, "Foods", capitalize(element["food"])), {
				IngredientArray: element["main ingredients"],
  				name: capitalize(element["food"]),
  				country: capitalize(element["country"]),
  				flavor: capitalize(element["flavor"]),
				image: "images/foodimages/" + element["food"].toLowerCase() + ".jpg",
				protein: element["protein"],
				meal: element["meal"],
				mainingredients: element["main ingredients"].join(", "),
				description: element["description"]

			});
		}
	}
	async function AssignRandomNumbers(){

	}
	// Initialize Firebase
	const app = initializeApp(firebaseConfig);
	//const analytics = getAnalytics(app);
	const db = getFirestore(app);
	const auth = getAuth();
	signInAnonymously(auth)
	.then(() => {
		console.log("Signed in")
	})
	.catch((error) => {
		const errorCode = error.code;
		const errorMessage = error.message;
		console.log(errorMessage);
		// ...
	});
	let uid = "";
	onAuthStateChanged(auth, (user) => {
		if (user) {
			// User is signed in, see docs for a list of available properties
			// https://firebase.google.com/docs/reference/js/auth.user
			uid = user.uid;
			// ...
		} else {
			// User is signed out
			// ...
		}
	});
	//SendFoods()

	let adCount = 4;
	let displayAd = false;
	let disableOpinionsButtons = false;
	let fullTitleArea = false;
	let openingModal = false;
	let modalType = 2;
	let adTime = 5000;
	let animatingSlide = false;
	let choiceString = "";
	const openTime = new Date().getTime();

	async function GetFoodData(name){
		const docRef = doc(db, "Foods", name);
		const docSnap = await getDoc(docRef);

		if (docSnap.exists()) {
			var jsonReturn = {
				name: docSnap.data().name, 
				image: docSnap.data().image, 
				mainingredients: docSnap.data().mainingredients,
				country: docSnap.data().country,
				flavor: docSnap.data().flavor,
				description: docSnap.data().description,
			}
			return jsonReturn;
		} else {
			console.log("No such document!");
		}
	}
	async function GetFoods(custom){
		const collectionRef = collection(db, "Foods")
		let q;
		let qArray = []
		let randomRange = ["AB", "BC", "CD", "DG", "GI", "IJ", "KM", "MN", "NR", "ST", "TZ"]
		if(!custom){
			let customRange = randomRange[Math.floor(Math.random()*randomRange.length)]
			qArray = [where("description", ">=", customRange.slice(0, 1)), where("description", "<=", customRange.slice(-1))];
		}
		else{
			let mealQ = where("meal", "==", userChoices.meal);
			let proteinQ = where("protein", "==", userChoices.protein);
			let countryQ = where("country", "==", userChoices.country)
			if(userChoices.country == "None"){
				countryQ = null;
			}
			if(userChoices.protein == "None"){
				proteinQ = null;
			}
			if(userChoices.meal == "None"){
				mealQ = null;
			}
			qArray = [mealQ, proteinQ, countryQ].filter(function (el) {
				return el != null;
			});
		}
		
		q = query(collectionRef, ...qArray, limit(50));
		let querySnapshot = await getDocs(q);
		let unshuffled = []
		querySnapshot.forEach((doc) => {unshuffled.push(doc);});
		let shuffled = unshuffled.map(value => ({ value, sort: Math.random() })).sort((a, b) => a.sort - b.sort).map(({ value }) => value);
		shuffled.forEach((doc) => {
			var jsonReturn = {
				name: doc.data().name, 
				image: doc.data().image, 
				mainingredients: doc.data().mainingredients,
				country: doc.data().country,
				flavor: doc.data().flavor,
				description: doc.data().description,
			}
			if(currentfood == null){
				currentfood = jsonReturn;
				usedfoods.push(currentfood);
				usedfoods = usedfoods;
			}
			foods.unshift(jsonReturn);
		});
	}
	//True is food, false is details
	let visisbleElement = true;
	let portrait = window.matchMedia("(orientation: portrait)").matches;
	var isMobileDevice = ('ontouchstart' in document.documentElement && /mobi/i.test(navigator.userAgent));
	function ChangeSize(e){
		if (!disableOpinionsButtons)
		{
			if(e.detail.text == 'l'){
				if(document.documentElement.clientWidth > 900){
					let bigbutton = document.getElementsByClassName('nobutton')[0];
					let smallbutton = document.getElementsByClassName('yesbutton')[0];
					bigbutton.style.width = "6em";
					bigbutton.style.height = "6em";
					smallbutton.style.width = "4em";
					smallbutton.style.height = "4em";
				}else{
					let selection = document.getElementsByClassName('selection')[0];
					selection.style.paddingRight = (window.screen.width / 6.25).toString() + "px";
				}
			}
			if(e.detail.text == 'r'){
				if(document.documentElement.clientWidth > 900){
					let bigbutton = document.getElementsByClassName('yesbutton')[0];
					let smallbutton = document.getElementsByClassName('nobutton')[0];
					bigbutton.style.width = "6em";
					bigbutton.style.height = "6em";
					smallbutton.style.width = "4em";
					smallbutton.style.height = "4em";
				}
				else{
					let selection = document.getElementsByClassName('selection')[0];
					selection.style.paddingLeft = (window.screen.width / 6.25).toString() + "px";
				}
			}
			if(e.detail.text == 'off'){
				if(document.documentElement.clientWidth > 900){
					let bigbutton = document.getElementsByClassName('yesbutton')[0];
					let smallbutton = document.getElementsByClassName('nobutton')[0];
					bigbutton.style.width = "5em";
					bigbutton.style.height = "5em";
					smallbutton.style.width = "5em";
					smallbutton.style.height = "5em";
				}
				else{
					let selection = document.getElementsByClassName('selection')[0];
					selection.style.paddingLeft = "0px";
					selection.style.paddingRight = "0px";
				}
			}
			if(e.detail.text == 'rend'){
				NextFood(true);
				if(document.documentElement.clientWidth > 900){
					let bigbutton = document.getElementsByClassName('yesbutton')[0];
					let smallbutton = document.getElementsByClassName('nobutton')[0];
					bigbutton.style.width = "5em";
					bigbutton.style.height = "5em";
					smallbutton.style.width = "5em";
					smallbutton.style.height = "5em";
				}
				else{
					let selection = document.getElementsByClassName('selection')[0];
					selection.style.paddingLeft = "0px";
					selection.style.paddingRight = "0px";
				}
			}
			if(e.detail.text == 'lend'){
				NextFood(false);
				if(document.documentElement.clientWidth > 900){
					let bigbutton = document.getElementsByClassName('yesbutton')[0];
					let smallbutton = document.getElementsByClassName('nobutton')[0];
					bigbutton.style.width = "5em";
					bigbutton.style.height = "5em";
					smallbutton.style.width = "5em";
					smallbutton.style.height = "5em";
				}
				else{
					let selection = document.getElementsByClassName('selection')[0];
					selection.style.paddingLeft = "0px";
					selection.style.paddingRight = "0px";
				}
			}
		}
	}	
	function FlipFoodElement(){
		const foodelement = document.querySelector(".food");
		const nobutton = document.querySelector(".buttonmediumno");
		const yesbutton = document.querySelector(".buttonmediumyes");
		let ogValue = visisbleElement;
		let fadeOutClasses = ['animate__animated', 'animate__fadeOut'];
		let fadeInClasses = ['animate__animated', 'animate__fade'];
		foodelement.classList.add('animate__animated', 'animate__flipOutY');
		nobutton.classList.add(...fadeOutClasses);
		yesbutton.classList.add(...fadeOutClasses);
		//, 'animate__faster'
		foodelement.addEventListener('animationend', function Flip(){
			if(visisbleElement == ogValue)
			{
				visisbleElement = !visisbleElement
			}
			let done = false;
			if(foodelement.className.includes('animate__flipInY')){
				done = true;
			}
 			foodelement.classList.remove('animate__animated', 'animate__flipOutY');
			nobutton.classList.remove(...fadeOutClasses);
			yesbutton.classList.remove(...fadeOutClasses);
			foodelement.classList.add('animate__animated', 'animate__flipInY');
			nobutton.classList.add(...fadeInClasses);
			yesbutton.classList.add(...fadeInClasses);
			if(done){
				foodelement.classList.remove('animate__animated', 'animate__flipInY');
				nobutton.classList.remove(...fadeInClasses);
				yesbutton.classList.remove(...fadeInClasses);
				foodelement.removeEventListener('animationend', Flip);
			}
		});
	}
	function RevealModal(){
		if(openingModal){
			return;
		}
		openingModal = true;
		let modal = document.getElementsByClassName("preferenceModal")[0];
		modal.style.display = "block";
		let animationout = 'animate__fadeIn';
		modal.classList.add('animate__animated', animationout, "animate__faster");
		modal.addEventListener('animationend', async function NextAnimate() {
			setTimeout( function() {openingModal = false;}, 250);
			modal.classList.remove('animate__animated', animationout, "animate__faster");
			modal.removeEventListener('animationend', NextAnimate);
		});
	}
	function CloseModal(overrideClose = false){
		let modal = document.getElementsByClassName("preferenceModal")[0];
		if (modal.className.includes("animate__animated") || (openingModal && overrideClose)){
			return;
		}
		if(modalType == 2){
			Cookies.set("infoModal", "shown");
		}
		openingModal = false;
		let animationout = 'animate__fadeOut';
		modal.classList.add('animate__animated', animationout, "animate__faster");
		modal.addEventListener('animationend', async function NextAnimate() {
			modal.classList.remove('animate__animated', animationout, "animate__faster");
			modal.removeEventListener('animationend', NextAnimate);
			modal.style.display = "None";
		});
		

	}
	window.addEventListener("orientationchange", function() {
		portrait = !portrait;
	});

	let foods = [];
	let usedfoods = [];
	function wait(milliseconds) {
  		return new Promise(resolve => setTimeout(resolve, milliseconds));
	}
	let userChoices = {
		meal: "None",
		protein: "None",
		country: "None",
	}
	GetFoods(false);
	let currentfood = null;
	
	function changeButtonColors(){
		if(document.getElementsByClassName('yesbutton').length != 0){
			document.getElementsByClassName('nobutton')[0].disabled = disableOpinionsButtons;
			document.getElementsByClassName('yesbutton')[0].disabled = disableOpinionsButtons;
		}
	}

	$: disableOpinionsButtons, changeButtonColors();

	function NextFood(yes){
		if (!disableOpinionsButtons)
		{
			adCount += 1;
			disableOpinionsButtons = true;
			animatingSlide = true;
			const foodelement = document.querySelector(".food");
			let animationout = 'animate__backOutUp';
			let animationin = 'animate__backInUp';
			if(yes){
				animationout = 'animate__backOutRight';
				animationin = 'animate__backInRight';
			}
			else{
				animationout = 'animate__backOutLeft';
				animationin = 'animate__backInLeft';
			}
			foodelement.classList.add('animate__animated', animationout);
			let done = false
			if(!displayAd){
				choiceString += (currentfood.name) + (yes ? "$>" : "!>");
				setDoc(doc(db, "Choices", uid + " " + openTime), {
					choiceString: choiceString,
					user: uid,
					time: openTime,
					currentfood: currentfood.name
				});
			}
			foodelement.addEventListener('animationend', async function NextAnimate() {
				if(done){
					animatingSlide = false;
					foodelement.classList.remove('animate__animated', animationin);
					foodelement.removeEventListener('animationend', NextAnimate);
					disableOpinionsButtons = false;
				}
				if(foodelement.className.includes(animationout) && !done){
					currentfood = foods[0];
					usedfoods.push(currentfood);
					usedfoods = usedfoods;
					foods.splice(0, 1);
					if(foods.length == 0){
						GetFoods(false);
					}
					
					done = true;
					await wait(300);
					foodelement.classList.remove('animate__animated', animationout);
					foodelement.classList.add('animate__animated', animationin);
					
				}
				
			});
		}
	}
	function KeepOpen(event){
		event.stopPropagation();  
	}
	window.onclick = function(event) {
		CloseModal(true);
    }
	document.addEventListener("keydown", function(event) {
		let modal = document.getElementsByClassName("preferenceModal")[0];
		if(modal.style.display.toLowerCase() == "none")
		{
			if (event.code == "ArrowRight") {
				NextFood(true);
			}
			else if (event.code == "ArrowLeft") {
				NextFood(false);
			}
			else if (event.code == "Space") {
				FlipFoodElement();
			}
		}
	});

	function handleUserChoice(choice, button, buttontype){
		let choicebuttons = document.getElementsByClassName(buttontype);
		let deselected = false;
		Array.from(choicebuttons).forEach(element => {
			if (element.className.includes(" " + button + " ")){
				if(element.style.border == "0.25em solid black"){
					element.style.border = "0em solid transparent";
					userChoices[buttontype.slice(-16, -7)] = "None";
					deselected = true;
				}
				else{
					element.style.border = "0.25em solid black";
					userChoices[buttontype.slice(-16, -7)] = choice.split(" ").slice(0, -1).join(" ");
					
				}
			} 
			else{
				element.style.border = "0em solid transparent";
			}
		});
		let elementClasses = document.getElementsByClassName(buttontype)[button].className.split(" ");
		let specialClasses = [];
		Array.from(elementClasses).forEach(element => {
			if(["enable", "disable"].includes(element.split("-")[0])){
				specialClasses.push(element[0] + "-" + element.split("-")[1]);
			}
		});
		Array.from(specialClasses).forEach(element => {
			if(element[0] == "e"){
				Array.from(document.getElementsByClassName(element.split("-")[1] + "-choice")).forEach(enabledbuttons => {
					enabledbuttons.disabled = false;
				});
			}
			if(element[0] == "d"){
				userChoices[element.split("-")[1]] = "None";
				Array.from(document.getElementsByClassName(element.split("-")[1] + "-choice")).forEach(disabledbuttons => {
					disabledbuttons.disabled = !deselected;
					disabledbuttons.style.border = "0em solid transparent";
				});
			}
		})
		if(userChoices["country"] == "UK"){
			userChoices["country"] = "United Kingdom";
		}
		if(userChoices["country"] == "USA"){
			userChoices["country"] = "United States";
		}
	}
	let supportChoice = ""
	function handleUserSupportChoice(choice, button){
		let choicebuttons = document.getElementsByClassName("support-choice");
		Array.from(choicebuttons).forEach(element => {
			if (element.className.includes(" " + button + " ")){
				if(element.style.border == "0.25em solid black"){
					element.style.border = "0em solid transparent";
				}
				else{
					element.style.border = "0.25em solid black";
					supportChoice = choice;
				}
			} 
			else{
				element.style.border = "0em solid transparent";
			}
		});
	}
	function openModalType(type){
		//0 is customization, 1 is support, 2 is welcome page, 3 is share
		modalType = type;
		RevealModal();
	}
	async function ReportIssue(){
		const d = new Date();
		let time = d.getTime();
		await setDoc(doc(db, "Messages", uid + " " + time.toString()), {
			issuetype: supportChoice,
			message: document.getElementsByClassName("issue-textbox")[0].value,
			currentfood: currentfood.name,
		});
	}
	
	let showinfoModal = Cookies.get('infoModal');

	function TakePicture(){
		const node = document.querySelector(".food")
 
		htmlToImage.toPng(node)
			.then(function (dataUrl) {
				let img = new Image();
				img.src = dataUrl;
				document.body.appendChild(img);
			})
			.catch(function (error) {
				console.error('oops, something went wrong!');
				console.log(error)
			});
	}

</script>
<body>
	{#if (portrait || window.screen.height >= 600) || !isMobileDevice}
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<div class="maincontent" >
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<div class="titlebar">
			<span class="material-symbols-outlined" on:click={() => openModalType(2)} style="font-size: 2em; color:black;">info</span>
			<span class="material-symbols-outlined" on:click={() => openModalType(0)} style="font-size: 2em; color:black;">tune</span> 
			<img src="images/ToothPickybigger.svg" alt="Toothpicky" class="title" on:click={TakePicture}> 
			<span class="material-symbols-outlined" on:click={() => openModalType(3)} style="font-size: 2em; color:black;">history</span>
			<span class="material-symbols-outlined" on:click={() => openModalType(1)} style="font-size: 2em; color:black;">contact_support</span>
			
		</div>
		<div class="preferenceModal" style="display: {showinfoModal != undefined ? "None" : "block"}">
			<div id="myModal" class="modal" >
				{#if modalType == 0}
				<!-- Modal content -->
				<div class="modal-content" on:click={KeepOpen}>
					<div class="modal-row" style="justify-content: space-between;"><h1 class="customize-title">Customize:</h1><span class="close" on:click={() => CloseModal(false)}>&times;</span></div>
					<div class="modal-row" style="justify-content: flex-start;"><h2 class="modal-title">Meal: </h2></div>
					<div class="modal-row">
						{#each ["Breakfast 🍳", "Lunch/Dinner 🍕", "Dessert 🍨", "Snack 🍿"] as meal, i}
							<button class="choice-button meal-choice {i} {["Dessert 🍨", "Snack 🍿"].includes(meal) ? "disable-protein" : "enable-protein"}" on:click={() => handleUserChoice(meal, i, "meal-choice")}>{meal}</button>
						{/each}
					</div>
					<div class="modal-row" style="justify-content: flex-start;"><h2 class="modal-title">Protein: </h2></div>
					<div class="modal-row">
						{#each ["Chicken 🐔", "Beef 🐄", "Pork 🐷", "Seafood 🐟", "Other Meat 🥩", "Veggie/Other 🥕"] as protein, i}
							<button class="choice-button protein-choice {i}" on:click={() => handleUserChoice(protein, i, "protein-choice")}>{protein}</button>
						{/each}
					</div>
					<div class="modal-row" style="justify-content: flex-start;"><h2 class="modal-title">Nationality: </h2></div>
					<div class="modal-row">
						{#each ["Italy 🇮🇹", "UK 🇬🇧", "France 🇫🇷", "Mexico 🇲🇽", "Greece 🇬🇷", "Japan 🇯🇵", "USA 🇺🇸", "China 🇨🇳"] as country, i}
							<button class="choice-button country-choice {i}" on:click={() => handleUserChoice(country, i, "country-choice")}>{country}</button>
						{/each}
					</div>
					<br>
					<div class="modal-row"><button class="choice-button" style='width: 12em; border: 0.125em solid black;' on:click={() => GetFoods(true)} on:click={() => CloseModal(false)}>Apply 🔍</button></div>

				</div>
				{:else if modalType == 1}
				<div class="modal-content" on:click={KeepOpen}>
					<div class="modal-row" style="justify-content: space-between;"><h1 class="customize-title">Report Issue</h1><span class="close" on:click={() => CloseModal(false)}>&times;</span></div>
					<div class="modal-row" style="justify-content: flex-start;"><h2 class="modal-title">Issue Category</h2></div>
					<div class="modal-row">
						{#each ["Issue with Text/Image Loading", "Website Feature Broken", "Food Information is Inaccurate", "Suggest a New Feature", "Other"] as support, i}
							<button class="choice-button support-choice {i}" on:click={() => handleUserSupportChoice(support, i)}> {support}</button>
						{/each}
					</div>
					<div class="modal-row" style="justify-content: flex-start;"><h2 class="modal-title">Describe the Issue</h2></div>
					<textarea class="text-box issue-textbox"></textarea>
					<div class="modal-row"><button class="choice-button" style='width: 12em; border: 0.125em solid black;' on:click={ReportIssue} on:click={() => CloseModal(false)}>Report 📢</button></div>
				</div>
				{:else if modalType == 2}
				<div class="modal-content" on:click={KeepOpen}>
					<div class="modal-row" style="justify-content: space-between;"><h1 class="customize-title">Welcome to Toothpicky</h1><span class="close" on:click={() => CloseModal(false)}>&times;</span></div>
					<ul class="modal-text">
						<li>Explore a variety of foods by swiping through the options ✔️❌</li>
						<li>View details about the food, like a description, flavor, main ingredients, country of origin 👁️</li>
						<li>Customize your search to get more personalized results! 🔎</li>
						<li>Order the food or find restaurants on your favorite apps in one click! 🍽️</li>
					</ul>
					<div class="modal-row" style="justify-content: center;"><h3 class="modal-title">Ready to Explore Toothpicky?</h3></div>
					<div class="modal-row"><button class="choice-button" style='width: 12em; border: 0.125em solid black;' on:click={() => CloseModal(false)}>Sounds Good 👍</button></div>

				</div>
				{:else if modalType == 3}
				<div class="modal-content" on:click={KeepOpen}>
					<div class="modal-row" style="justify-content: space-between;"><h1 class="customize-title">History</h1><span class="close" on:click={() => CloseModal(false)}>&times;</span></div>
					<ul class="modal-text" style="overflow: auto; max-height: 30vh;">
						{#if usedfoods.length > 1}
							{#each usedfoods.slice(0, -1).reverse() as fooddata}
								{#if fooddata != null}
									<li><div style="display: flex; place-content: center space-between">{fooddata.name}<span class="material-symbols-outlined" on:click={() => currentfood = fooddata}>undo</span></div></li>
								{/if}
							{/each}
						{:else}
						<div class="modal-row" style="justify-content: center;"><h3 class="modal-title">No Food History. Explore Some Foods!</h3></div>
						{/if}
					</ul>
				</div>
				{/if}
			  </div>	
		</div>
		<div class="selection">
			<div class="no">
				<div class="buttonmediumno">
					{#if visisbleElement == true}
					<button class="nobutton" on:click={() => NextFood(false)} ><span class="material-symbols-outlined" id="nosymbol">close</span></button>
					{:else}
					<button class="nobutton" style="opacity: 0;"><span class="material-symbols-outlined" id="nosymbol">close</span></button>
					{/if}
				</div>
			</div>
			<div class="food">
				{#if currentfood != null}
					{#if visisbleElement == true}
						<div class="foodelement"><Food on:sway={ChangeSize} on:view={FlipFoodElement} foodName={currentfood.name} image={currentfood.image}/></div>
					{:else}
						<div class="detailselement"><Details on:view={FlipFoodElement} foodName={currentfood.name} country={currentfood.country} mainingredients={currentfood.mainingredients} flavor={currentfood.flavor} description={currentfood.description}></Details></div>			
					{/if}
				{/if}
			</div>
			<div class="yes">
				<div class="buttonmediumyes">
					{#if visisbleElement == true}
					<button class="yesbutton" on:click={() => NextFood(true)}><span class="material-symbols-outlined" id="yessymbol">done</span></button>
					{:else}
					<button class="yesbutton" style="opacity: 0;"><span class="material-symbols-outlined" id="yessymbol">done</span></button>
					{/if}
				</div>
			</div>
		</div>
	</div>
{:else}

	<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: block"><p class="rotatetext">Please rotate your device</p></div>
	
{/if}
</body>



<style>
	:root{
		--red: #EDA79E;
		--green: #C8FEAF;
		overflow: hidden;
		scrollbar-width: 0;
		--percent: 50%;
		background-image: linear-gradient(to left, var(--green) 0%, var(--green) var(--percent), var(--red) var(--percent), var(--red) 100%);
		transition: background-image 0.2s;
		user-select: none;
	}
	.preferenceModal{
		display: block; /* Hidden by default */
  		position: fixed; /* Stay in place */
		z-index: 1; /* Sit on top */
		left: 0;
		top: 0;
		width: 100%; /* Full width */
		height: 100%; /* Full height */
		background-color: rgb(0,0,0); /* Fallback color */
		background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
	}
	#myModal{
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-content {
		background-color: #fefefe;
		z-index: 2;
		padding: 20px;
		border: 1px solid #888;
		width: 75%;
		border-radius: 1em;
		max-height: 92%;
	}
	.close {
		color: #aaa;
		float: right;
		font-size: 28px;
		font-weight: bold;
		padding-bottom: 10px;
		user-select: none;
	}
	.close:hover {
		cursor: pointer;
	}
	.modal-row{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-around;
		gap: 0.2em;
	}
	.choice-button{
		background-color: #FAD074;
		border-width: 1em;
		border: solid;
		border-radius: 2em;
		border-color: transparent;
		width: 10em;
		height: 2em;
		text-align: center;
		display: inline-flex;
  		align-items: center;
		justify-content: center;
		font-size: 1em;
		transition: 500ms;
	}
	.choice-button:hover {
		cursor: pointer;
	}
	.choice-button:disabled{
		color: #474747;
		background-color: #af9760;
		transition: 500ms;
	}
	.support-choice{
		width: 15em;
		height: 3em;
	}
	.modal-title{
		user-select: none;
		font-size: 1.6em;
	}
	.customize-title{
		user-select: none;
		font-size: 2em;
	}
	.text-box{
		width: 40em;
		height: 12em;
		resize: none;
	}
	.modal-text{
		font-size: 1.5em;
		word-wrap: normal;
		text-align: left;
		border: 0.25em solid black; 
		border-radius: 1.5em; 
		padding: 2em;
	}
	.titlebar{
		color: white;
		background-color: transparent;
		min-height: 3em;
		border-bottom-left-radius: 1em;
		border-bottom-right-radius: 1em;
		text-align: center;
		user-select: none;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		gap: 2em;
	}
	.selection{
		--percent: 50%;
		display: flex;
		flex-direction: row;
		background-image: linear-gradient(to left, var(--green) 0%, var(--green) var(--percent), var(--red) var(--percent), var(--red) 100%);
		overflow: hidden;
		transition: all 0.2s ease-in;
	}
	.no{
		flex-grow: 3;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		align-items: center;
		user-select: none;
	}
	.food{
		flex-grow: 2;
		text-align: center;
	}
	.foodelement{
		flex-grow: 2;
	}
	.detailselement{
		flex-grow: 6;
		padding-left: 4px;
	}
	.yes{
		flex-grow: 3;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		align-items: center;
		user-select: none;
	}
	.nobutton{
		border-radius: 20em;
		border-style: solid;
		border-color: #1B1B1B;
		border-width: 0.2em;
		background-color: var(--red);
		width: 5em;
		height: 5em;
		display: inline;
		transition: all 0.2s;
	}
	.nobutton:active{
		background-color: #f14f39;
	}
	.nobutton:disabled{
		background-color: #acacac;
	}
	.yesbutton{
		border-radius: 20em;
		border-style: solid;
		border-color: #1B1B1B;
		border-width: 0.2em;
		background-color: var(--green);
		width: 5em;
		height: 5em;
		display: inline;
		transition: all 0.2s;
	}
	.yesbutton:active{
		background-color: #89ff4e;
	}
	.yesbutton:disabled{
		background-color: #acacac;
	}
	#nosymbol{
		color: #1B1B1B;
	}
	#yessymbol{
		color: #1B1B1B;
	}
	.title{
		max-height: 6em;
		align-self: center;
		width: 12em;
	}
	.maincontent{
		text-align: center;
	}
	.rotatetext{
		font-size: 4.5em;
		text-align: center;
	}
	@media only screen and (max-width: 900px) {
		.buttonmediumno{
			display: none;
			z-index: 2;
		}
		.buttonmediumyes{
			display: none;
			z-index: 2;
		}
		.detailselement{
			padding-left: 0px;
		}
		.choice-button{
			width: 9.1em;
			height: 2em;
			font-size: 0.9em;
		}
		.modal-title{
			font-size: 1.4em;
		}
		.customize-title{
			font-size: 1.8em;
		}
		.text-box{
			width: 30em;
			height: 12em;
		}
		.support-choice{
			width: 12em;
			height: 3em;
		}
		.modal-text{
			font-size: 1.2em;
			padding: 1.8em;
		}
	}
	@media only screen and (max-width: 700px) {
		.titlebar{
			color: white;
			min-height: 3em;
			border-bottom-left-radius: 1em;
			border-bottom-right-radius: 1em;
			text-align: center;
			gap: 1em;
		}
		.selection{
			--percent: 50%;
			display: flex;
			flex-direction: row;
			background-image: linear-gradient(to left, #C8FEAF 0%, #C8FEAF var(--percent), #EDA79E var(--percent), #EDA79E 100%);
			overflow: hidden;
			transition: all 0.2s ease-in;
		}
		.no{
			flex-grow: 3;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;
			align-items: center;
		}
		.food{
			flex-grow: 2;
		}
		.foodelement{
			flex-grow: 2;
		}
		.detailselement{
			flex-grow: 6
		}
		.yes{
			flex-grow: 3;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;
			align-items: center;
		}
		.nobutton{
			border-radius: 20em;
			border-style: solid;
			border-color: #1B1B1B;
			border-width: 0.2em;
			background-color: #EDA79E;
			width: 3em;
			height: 3em;
			display: inline;
			transition: all 0.2s;
		}
		.nobutton:active{
			background-color: #f14f39;
		}
		.yesbutton{
			border-radius: 20em;
			border-style: solid;
			border-color: #1B1B1B;
			border-width: 0.2em;
			background-color: #C8FEAF;
			width: 3em;
			height: 3em;
			display: inline;
			transition: all 0.2s;
		}
		.yesbutton:active{
			background-color: #89ff4e;
		}
		#nosymbol{
			color: #1B1B1B;
		}
		#yessymbol{
			color: #1B1B1B;
		}
		.title{
			max-height: 6em;
			width: 12em;
		}
		.buttonmediumno{
			display: none;
			z-index: 2;
		}
		.buttonmediumyes{
			display: none;
			z-index: 2;
		}
		.food{
			flex-grow: 4;
		}
		.foodelement{
			flex-grow: 4;
		}
		.choice-button{
			width: 8.6em;
			height: 2em;
			font-size: 0.7em;
		}
		.modal-title{
			font-size: 1.2em;
		}
		.customize-title{
			font-size: 1.4em;
		}
		.text-box{
			width: 16em;
			height: 10em;
		}
		.support-choice{
			width: 10em;
			height: 2.8em;
		}
		.modal-text{
			font-size: 1em;
			padding: 1.5em;
		}
    }
	@media only screen and (max-width: 400px) {
		.text-box{
			width: 10em;
			height: 7em;
		}
		.title{
			max-height: 4em;
			width: 8em;
		}
		.titlebar{
			gap: 0.5em;
		}
	}
</style>
